import { VILLES_QUARTIERS_CI, AUTRE_QUARTIER, COMMUNES_ABIDJAN } from "@/lib/villesQuartiers";

export const QuartierFilter = ({ ville, commune, setCommune, quartier, setQuartier }) => {
  if (!ville || ville === "Tous") return null;
  const estAbidjan = ville === "Abidjan";
  const source = estAbidjan ? commune : ville;
  const quartiers = source ? (VILLES_QUARTIERS_CI[source] || []).filter((q) => q !== AUTRE_QUARTIER) : [];
  const selectCls =
    "bg-white border border-[#E5DFD5] rounded-full px-4 py-2 text-sm text-stone-700 focus:outline-none focus:ring-2 focus:ring-stone-300 transition-all";

  return (
    <>
      {estAbidjan && (
        <select
          value={commune}
          onChange={(e) => {
            setCommune(e.target.value);
            setQuartier("");
          }}
          data-testid="filter-commune"
          className={selectCls}
        >
          <option value="">Toutes les communes</option>
          {COMMUNES_ABIDJAN.map((c) => (
            <option key={c} value={c}>{c.replace("Abidjan - ", "")}</option>
          ))}
        </select>
      )}
      {(!estAbidjan || commune) && quartiers.length > 0 && (
        <select
          value={quartier}
          onChange={(e) => setQuartier(e.target.value)}
          data-testid="filter-quartier"
          className={selectCls}
        >
          <option value="">Tous les quartiers</option>
          {quartiers.map((q) => (
            <option key={q}>{q}</option>
          ))}
        </select>
      )}
    </>
  );
};
